export enum Governorate {
    AlAnbar = 'Al Anbar',
    AlMuthanna = 'Al Muthanna',
    AlQadisiyah = 'Al Qadisiyah',
    Babylon = 'Babylon',
    Baghdad = 'Baghdad',
    Basrah = 'Basrah',
    Dhiqar = 'Dhiqar',
    Diyala = 'Diyala',
    Duhok = 'Duhok',
    Erbil = 'Erbil',
    Karbala = 'Karbala',
    Kirkuk = 'Kirkuk',
    Maysan = 'Maysan',
    Najaf = 'Najaf',
    Nineveh = 'Nineveh',
    Saladin = 'Saladin',
    Sulaymaniyah = 'Sulaymaniyah',
    Wasit = 'Wasit'
}
